import { memo } from 'react';

import { handleKeyboardClick } from '@/utils/accessibility';
import { isEyewearEnabled } from '@/utils/eyewear';

import type { SearchHit } from '@/integrations/algolia/types';

import { getGroupLabel, getHitName } from './utils';

import * as S from './AlgoliaSearchInput.styles';

interface SearchDropdownProps {
  draftMode: boolean;
  groupedHits: { groupKey: string; hits: SearchHit[] }[];
  onHintClick: (hit: SearchHit) => void;
  regionLocale: any;
}

export const SearchDropdown = memo(
  ({
    draftMode,
    groupedHits,
    onHintClick,
    regionLocale,
  }: SearchDropdownProps) => {
    let filteredHits = groupedHits;
    if (!isEyewearEnabled(draftMode)) {
      filteredHits = groupedHits.filter(
        (group) => group.groupKey !== 'Eyewear',
      );
    }

    return (
      <S.Results data-testid='AlgoliaSearchInputResults'>
        {filteredHits.map(({ groupKey, hits }, groupIndex) => (
          <div key={groupKey}>
            <S.GroupLabel as='div'>{getGroupLabel(groupKey)}</S.GroupLabel>

            {hits.map((hit, index) => {
              const nameString = getHitName(hit, regionLocale) ?? '';

              return (
                <S.Result
                  key={`${hit.objectID}-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: nameString,
                  }}
                  data-test-id={`AlgoliaSearchInputResult-${groupIndex}-${index}`}
                  onClick={() => onHintClick(hit)}
                  onKeyDown={handleKeyboardClick}
                />
              );
            })}
            {groupIndex < groupedHits.length - 1 && <S.Separator />}
          </div>
        ))}
      </S.Results>
    );
  },
);

SearchDropdown.displayName = 'SearchDropdown';
